import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  LinearProgress,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import CustomMenuList from "../../customComponents/CustomMenuList";
import { useGetClassesQuery } from "../classroom/classApiSlice";
import AttendanceSheet from "./AttendanceSheet";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

function ManageAttendance() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeTab, setActiveTab] = useState(0);
  const [openClasses, setOpenClasses] = useState(true);

  const { data: myClasses, isLoading: myClassesLoading } =
    useGetClassesQuery("all/mine");

  const handleClassChange = (index) => {
    setActiveTab(index);
    if (isMobile) {
      setOpenClasses(false);
    }
  };

  return (
    <Grid container columnSpacing={3}>
      <Grid item xs={12} md={3}>
        {isMobile ? (
          <Accordion
            expanded={openClasses}
            onChange={(_, expanded) => setOpenClasses(expanded)}
            disableGutters
            sx={{ mb: 1 }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>Classes</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>
              {myClassesLoading && <LinearProgress />}
              <CustomMenuList
                activeTab={activeTab}
                setActiveTab={handleClassChange}
                heading="menu"
                list={myClasses?.map((classroom) => `${classroom.name} attendance`)}
                icon={<CalendarMonthIcon />}
              />
            </AccordionDetails>
          </Accordion>
        ) : (
          <>
            {myClassesLoading && <LinearProgress />}
            <CustomMenuList
              activeTab={activeTab}
              setActiveTab={handleClassChange}
              heading="menu"
              list={myClasses?.map((classroom) => `${classroom.name} attendance`)}
              icon={<CalendarMonthIcon />}
            />
          </>
        )}
      </Grid>
      <Grid item xs={12} md={9}>
        <AttendanceSheet myClasses={myClasses || []} activeTab={activeTab} />
      </Grid>
    </Grid>
  );
}

export default ManageAttendance;
